<template>
  <div class="fav-container">
    <div class="main-content">
      <el-card shadow="never" class="fav-card">
        <div slot="header" class="card-header">
          <div class="header-title">
            <i class="el-icon-star-on header-icon" />
            <span>我的收藏</span>
            <span class="fav-count">（{{ favList.length }}）</span>
          </div>
          <el-input
            v-model="searchKey"
            placeholder="搜索收藏的商品"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            class="search-input"
          />
        </div>

        <!-- 1. 收藏网格列表 -->
        <div v-loading="loading" class="fav-body">
          <div v-if="filteredFavList.length === 0" class="empty-box">
            <el-empty description="暂无收藏商品" :image-size="120" />
          </div>

          <el-row v-else :gutter="16">
            <el-col
              v-for="item in filteredFavList"
              :key="item.id"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="6"
              class="fav-col"
            >
              <div class="fav-item-card">
                <!-- 角标提示 -->
                <div v-if="item.isPriceDrop" class="badge-tag">降价促销</div>

                <div class="img-wrapper">
                  <img :src="item.picUrl || defaultPic" class="goods-img" alt="商品图片">
                  <div class="mask-actions">
                    <el-button
                      type="danger"
                      icon="el-icon-shopping-cart-2"
                      circle
                      title="移入购物车"
                      @click="addToCart(item)"
                    />
                    <el-button
                      type="info"
                      icon="el-icon-delete"
                      circle
                      title="取消收藏"
                      @click="removeFav(item)"
                    />
                  </div>
                </div>

                <div class="card-info">
                  <div class="goods-title" :title="item.title">{{ item.title }}</div>
                  <div class="price-bar">
                    <span class="current-price">￥{{ item.price }}</span>
                    <span v-if="item.originalPrice" class="origin-price">￥{{ item.originalPrice }}</span>
                  </div>
                  <div class="card-footer-action">
                    <el-button type="text" class="cart-btn" @click="addToCart(item)">
                      <i class="el-icon-shopping-cart-2" /> 加入购物车
                    </el-button>
                    <el-button type="text" class="del-text-btn" @click="removeFav(item)">取消</el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fav',
  data() {
    return {
      text: '收藏夹',
      loading: false,
      searchKey: '',
      defaultPic: 'https://via.placeholder.com/200',
      favList: [
        { id: 1, title: '【秒杀专享】高性能云服务器 2核4G 10M带宽', price: '99.00', originalPrice: '199.00', isPriceDrop: true, picUrl: '' },
        { id: 2, title: '极客风机械键盘 108键红轴 RGB背光', price: '299.00', originalPrice: '', isPriceDrop: false, picUrl: '' },
        { id: 3, title: '27英寸 4K IPS 显示器 144Hz 刷新率', price: '1499.00', originalPrice: '1699.00', isPriceDrop: true, picUrl: '' }
      ]
    }
  },
  computed: {
    filteredFavList() {
      if (!this.searchKey) return this.favList
      return this.favList.filter(item => item.title.includes(this.searchKey))
    }
  },
  created() {
    document.title = this.text
  },
  methods: {
    addToCart(item) {
      this.$message.success(`已将 "${item.title.substring(0, 8)}..." 加入购物车`)
    },
    removeFav(item) {
      this.$confirm('确定要取消收藏该商品吗？', '提示', { type: 'warning' }).then(() => {
        this.favList = this.favList.filter(i => i.id !== item.id)
        this.$message.success('已取消收藏')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.fav-container {
  min-height: 100vh;
  background-color: #f8fafc;
  padding: 24px 0;
}

.main-content {
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 16px;
}

.fav-card {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-icon {
  color: #f59e0b;
}

.fav-count {
  font-size: 14px;
  color: #64748b;
  font-weight: normal;
}

.search-input {
  width: 220px;
}

.fav-body {
  min-height: 200px;
}

.empty-box {
  padding: 60px 0;
}

.fav-col {
  margin-bottom: 16px;
}

.fav-item-card {
  position: relative;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  transition: all 0.3s ease;
}

.fav-item-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
  border-color: #cbd5e1;
}

.badge-tag {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #ef4444;
  color: #fff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  z-index: 2;
  font-weight: 600;
}

.img-wrapper {
  position: relative;
  width: 100%;
  padding-top: 100%; /* 1:1 比例 */
  overflow: hidden;
  background-color: #f8fafc;
}

.goods-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.fav-item-card:hover .goods-img {
  transform: scale(1.05);
}

.mask-actions {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.fav-item-card:hover .mask-actions {
  opacity: 1;
}

.card-info {
  padding: 12px;
}

.goods-title {
  font-size: 13px;
  color: #1e293b;
  font-weight: 600;
  line-height: 1.4;
  height: 36px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 8px;
}

.price-bar {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 8px;
}

.current-price {
  font-size: 16px;
  color: #ef4444;
  font-weight: 700;
}

.origin-price {
  font-size: 12px;
  color: #94a3b8;
  text-decoration: line-through;
}

.card-footer-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  padding-top: 6px;
}

.cart-btn {
  color: #3b82f6;
  font-size: 12px;
  padding: 0;
}
.cart-btn:hover {
  color: #2563eb;
}

.del-text-btn {
  color: #94a3b8;
  font-size: 12px;
  padding: 0;
}
.del-text-btn:hover {
  color: #ef4444;
}
</style>
